import React from 'react';
import PropTypes from 'prop-types';
import Script from 'next/script';
import { Lang } from '@deporvillage/frontend-common';

let isInit = false;

const OneTrust = ({ id, lang, script }) => {
    const dispatchOptanon = () => {
        if (!isInit) return;

        // eslint-disable no-undef
        window.dispatchEvent(new CustomEvent('cookieCompliance:onChange', {
            detail: {
                isBannerClosed: window.OneTrust && window.OneTrust.IsAlertBoxClosed(),
                activeGroups: window.OnetrustActiveGroups,
            },
        }));
        // eslint-enable no-undef
    };

    const handleTracking = (event) => {
        if (event.detail.event !== 'trackOptanonEvent') return;
        // istanbul ignore next
        if (window.EBus) {
            window.EBus.push({
                type: 'ACTION',
                name: 'OPTANON_ACTION',
                ...event.detail,
            });
        }
    };

    React.useEffect(() => {
        // eslint-disable no-undef
        window.OptanonWrapper = () => {
            isInit = true;
            dispatchOptanon();
        };

        window.addEventListener('cookieCompliance:getData', dispatchOptanon);
        window.addEventListener('datalayerpush', handleTracking);

        return () => {
            window.removeEventListener('cookieCompliance:getData', dispatchOptanon);
            window.removeEventListener('datalayerpush', handleTracking);
        };
        // eslint-enable no-undef
    }, []);

    return (
            <Script
                id={'one-trust'}
                strategy={'beforeInteractive'}
                src={script}
                type='text/javascript'
                charSet='UTF-8'
                data-language={
                    [
                        // @toDo: temp patch to make OT work for new new domains
                        Lang.da_DK,
                        Lang.nl_NL,
                        Lang.pl_PL,
                    ].includes(lang) && Lang.en_GB || lang
                }
                data-domain-script={id}
                fetchpriority={'high'}
            />
    
    );
};

OneTrust.propTypes = {
    id: PropTypes.string,
    lang: PropTypes.string,
    script: PropTypes.string,
};

export default OneTrust;
